module.exports = __webpack_public_path__ + "static/img/4114_phase_function_Paper_PointsHejduk_Prediction.dca8c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4114_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Sgre
// module chunks = 0